import { render, staticRenderFns } from "./CreateInvite.vue?vue&type=template&id=4d4939f8&scoped=true&"
import script from "./CreateInvite.vue?vue&type=script&lang=js&"
export * from "./CreateInvite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4939f8",
  null
  
)

export default component.exports